<template>
  <section class="stab-list">
    <div class="stab-list-header">
      <h4 class="stab-list-title">
        <i class="el-icon-office-building"></i> Establecimientos
      </h4>
      <el-button
        size="small"
        class="stab-add-btn"
        @click="onClickAddStablishment"
      >
        <i class="el-icon-plus"></i> Nuevo
      </el-button>
    </div>

    <template v-if="apiResponse.success">
      <div
        v-for="(stab, index) in stablishments"
        :key="index"
        :class="['stab-card', { 'is-default': stab.is_default == 1 }]"
        @click.stop="onStablishmentView(stab)"
      >
        <div class="stab-card-icon">
          <i class="el-icon-office-building"></i>
        </div>
        <div class="stab-card-info">
          <div class="stab-card-name">{{ stab.name }}</div>
          <div class="stab-card-code">Código: {{ stab.code }}</div>
        </div>
        <div class="stab-card-actions">
          <el-tooltip
            :content="
              stab.is_default == 1
                ? 'Establecimiento por defecto'
                : 'Establecer como predeterminado'
            "
            placement="top"
          >
            <button
              :class="[
                'stab-action-btn',
                { 'is-active': stab.is_default == 1 }
              ]"
              @click.stop="setStablishmentDefault(stab)"
            >
              <i class="el-icon-check"></i>
            </button>
          </el-tooltip>
          <el-tooltip content="Editar" placement="top">
            <button
              class="stab-action-btn"
              @click.stop="onClickEditStablishment(stab)"
            >
              <i class="el-icon-edit"></i>
            </button>
          </el-tooltip>
        </div>
      </div>

      <div v-if="!stablishments.length" class="stab-empty">
        <i class="el-icon-office-building"></i>
        <span>No hay establecimientos registrados</span>
      </div>
    </template>

    <SkeletonOneCardComponent height="60px" v-else />

    <BusinessStablishmentAddComponent
      @onCloseDrawer="onCloseStablishmentAddDrawer"
      :visible.sync="visibleAddStablishment"
    />

    <BusinessStablishmentEditComponent
      @onCloseDrawer="onCloseStablishmentEditDrawer"
      :visible.sync="visibleEditStablishment"
    />
  </section>
</template>

<script>
import BusinessStablishmentAddComponent from "./StablishmentAdd";
import BusinessStablishmentEditComponent from "./StablishmentEdit";
import tradeService from "../../../services/tradeService";
import SkeletonOneCardComponent from "@/components/Animations/Loading/SkeletonOneCard";

export default {
  name: "BusinessStablishmentListComponent",
  data() {
    return {
      apiResponse: { success: false },
      visibleAddStablishment: false,
      visibleEditStablishment: false,
      stablishments: []
    };
  },
  methods: {
    toggleApiResponse(property, value) {
      this.apiResponse[property] = value;
    },
    onClickAddStablishment() {
      this.visibleAddStablishment = true;
    },
    onCloseStablishmentAddDrawer() {
      this.visibleAddStablishment = false;
    },
    onClickEditStablishment(stablishment) {
      this.$root.$emit("onStablishmentEdit", stablishment);
      this.visibleEditStablishment = true;
    },
    onCloseStablishmentEditDrawer() {
      this.visibleEditStablishment = false;
    },
    onStablishmentView(stablishment) {
      this.$emit("onStablishmentView", stablishment);
    },
    async setStablishmentDefault(stablishment) {
      try {
        let response = await tradeService.setStablishmentDefault(stablishment);
        if (response.data) {
          this.toggleApiResponse("success", true);
          this.getStablishments();
          this.$message.success("Establecimiento predeterminado actualizado");
        }
      } catch (error) {
        return false;
      }
    },
    async getStablishments() {
      try {
        let response = await tradeService.getStablishments();
        if (response.data.data) {
          this.stablishments = response.data.data;
          this.toggleApiResponse("success", true);

          // Auto-select default if only 1 and none selected
          if (
            this.stablishments.length === 1 &&
            this.stablishments[0].is_default != 1
          ) {
            this.setStablishmentDefault(this.stablishments[0]);
          }
        }
      } catch (error) {
        return false;
      }
    }
  },
  components: {
    BusinessStablishmentAddComponent,
    BusinessStablishmentEditComponent,
    SkeletonOneCardComponent
  },
  mounted() {
    this.getStablishments();
    this.$root.$on("onStablishmentAdd", () => {
      this.getStablishments();
    });
  }
};
</script>

<style lang="scss" scoped>
$primary: #31355c;
$accent: #3fdbbf;
$border: #e4eaf6;
$bg: #f7f8f9;

.stab-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.stab-list-title {
  font-size: 18px;
  font-weight: 700;
  color: $primary;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    font-size: 20px;
    color: $accent;
  }
}
.stab-add-btn {
  background: $accent !important;
  border-color: $accent !important;
  color: #fff !important;
  border-radius: 8px;
  font-size: 13px;

  &:hover {
    opacity: 0.9;
  }
}

.stab-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  background: #fff;
  border: 1px solid $border;
  border-radius: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    border-color: darken($border, 10%);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }

  &.is-default {
    border-left: 3px solid $accent;
  }
}
.stab-card-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: $bg;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i {
    font-size: 18px;
    color: $primary;
  }
}
.stab-card-info {
  flex: 1;
  min-width: 0;
}
.stab-card-name {
  font-size: 15px;
  font-weight: 600;
  color: $primary;
}
.stab-card-code {
  font-size: 13px;
  color: #909399;
  margin-top: 2px;
}
.stab-card-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}
.stab-action-btn {
  width: 34px;
  height: 34px;
  border: 1px solid $border;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #909399;
  transition: all 0.15s;

  &:hover {
    background: $bg;
    color: $primary;
    border-color: $primary;
  }

  &.is-active {
    background: #e4fff4;
    border-color: $accent;
    color: #1d9e75;
  }
}

.stab-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  color: #c0c4cc;
  gap: 8px;

  i {
    font-size: 32px;
  }

  span {
    font-size: 14px;
  }
}
</style>
